import { useMediaQuery } from "@material-ui/core";
import React from "react";

import { ReactComponent as WinterBreakImage } from "assets/winter-break.svg";
import { StyledGrid, StyledP } from "components/simple";
import {
  breakpoints,
  color,
  fontFamily,
  fontSize,
  spacingDefaults
} from "style/constants";
//import { useQuery } from "@apollo/react-hooks";
//import { BannerInfo } from "graphql/bannerInfo/bannerInfo.gql.ts";

const RetakeAssessmentsBanner: React.FC = () => {
  const mobile = useMediaQuery(`(max-width:${breakpoints.lg}px)`);
  //const { data: bannerInfo } = useQuery(BannerInfo);
  return (
    <StyledGrid
      container
      backgroundColor={color.WHITE}
      borderRadius="8px"
      alignContent="center"
      alignItems="center"
      itemMargin={spacingDefaults.xsmall}
      padding={spacingDefaults.xsmall}
      maxHeight={mobile ? "none" : "96px"}
      justifyContent={mobile ? "center" : "flex-start"}
      textAlign={mobile ? "center" : "left"}
      marginBottom="2rem"
      mobileMarginBottom="0"
    >
      <StyledGrid item>
        <WinterBreakImage />
      </StyledGrid>
      <StyledGrid item lg>
        <StyledP
          color={color.BLACK}
          fontFamily={fontFamily.secondary}
          fontSize={fontSize.large}
          letterSpacing="-0.5px"
          margin="0.5rem 0"
        >
          Out on Holiday: See You Next Year!
          {/* {bannerInfo?.getBannerInfo?.winterBreakBannerInfo?.winterBannerTitle} */}
        </StyledP>
        <StyledP color={color.DARKERGRAY} margin={"0.5rem 0"}>
          Our team is taking a brain-healthy holiday from 12/21-1/5 to recharge
          and refresh.
          {/* {bannerInfo?.getBannerInfo?.winterBreakBannerInfo?.winterBannerBody} */}
        </StyledP>
      </StyledGrid>
    </StyledGrid>
  );
};

export default RetakeAssessmentsBanner;
